import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { User } from "@/classes";
import PaginatedTable from "@/components/base/tables/PaginatedTable.vue";
import UserDialog from "@/components/dialogs/UserDialog.vue";
import { useAuthStore } from "@/store/auth";
import { useListStore } from "@/store/lists";
import { FilterDefinition } from "@/types/filter";
import { DataTableHeader } from "@/types/table";
import { onBeforeUnmount, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'users',
  setup(__props) {

const $auth = useAuthStore();
const lists = useListStore();
onBeforeUnmount(() => {
  if ($auth.state.user) {
    lists.refreshList("users");
  }
});

const headers: DataTableHeader[] = [
  {
    title: "Email",
    key: "email",
  },
  {
    title: "Name",
    key: "name",
  },
  {
    title: "Admin",
    key: "admin",
  },
  {
    title: "Actions",
    key: "actions",
    sortable: false,
  },
];

const filterDefinitions: FilterDefinition[] = [
  {
    label: "Email",
    value: "email",
    type: "string",
  },
];

const table = ref<InstanceType<typeof PaginatedTable> | null>(null);
const dialog = ref<InstanceType<typeof UserDialog> | null>(null);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(PaginatedTable, {
    ref_key: "table",
    ref: table,
    table: "users",
    "table-class": _unref(User),
    "filter-definitions": filterDefinitions,
    headers: headers
  }, {
    "right-actions": _withCtx(() => [
      _createVNode(_component_v_btn, {
        color: "primary",
        flat: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value?.open(null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "mr-1" }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-plus")
            ]),
            _: 1
          }),
          _createTextVNode("User ")
        ]),
        _: 1
      })
    ]),
    "item.actions": _withCtx(({ item }) => [
      _createVNode(_component_v_btn, {
        icon: "mdi-pencil",
        flat: "",
        density: "compact",
        onClick: ($event: any) => (dialog.value?.open(item.id))
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(UserDialog, {
        ref_key: "dialog",
        ref: dialog,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (table.value?.getData()))
      }, null, 512)
    ]),
    _: 1
  }, 8, ["table-class"]))
}
}

})